<template>
  <div class="apptree">
    <div class="treelist">
      <template v-for="(item, i) in treeData">
        <div class="treeitem" :key="i + item.label">
          <div class="row" @click="checkRow(item, i)">
            <div class="dur" :class="{ open: item.check }" v-show="item.child"></div>
            <div class="gou" v-if="item.child">
              <input type="checkbox" v-model="item.check" />
            </div>
            <span>{{ item.label }}</span>
          </div>
          <div class="itemchild" v-if="item.child" v-show="item.check">
            <TreeCom :treeData="item.child" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: "TreeCom",
  props: {
    treeData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    checkRow(row, i) {
      // this.reset(all);
      this.treeData.forEach((row, idx) => {
        if (idx != i) {
          row.check = false;
        }
      });
      
      row.check = !row.check;
      this.$emit("onSelect", row)
    },
    reset(list) {
      list.forEach((row) => {
        row.check = false;
      });
    },
  },
};
</script>
<style lang="less">
.apptree {
  width: 280px;
  .row {
    padding: 6px 0;
    font-size: 14px;
    color: #242a32;
    display: flex;
    align-items: center;

    .dur {
      width: 13px;
      height: 13px;
      border-radius: 50%;
      position: relative;
      margin-right: 8px;
      transition-duration: 0.3s;
      &::after {
        content: "";
        display: block;
        width: 0;
        height: 0;
        border: 4px solid transparent;
        border-bottom: 0px solid transparent;
        border-top: 5px solid #c4c4c4;
        position: absolute;
        top: 50%;
        margin-top: -2px;
        left: 50%;
        margin-left: -5px;
      }
      &:hover {
        background: #aad8fd;
        &::after {
          border-top-color: #fff;
        }
      }
    }
    .gou {
      margin-right: 8px;
      width: 16px;
      height: 16px;
      position: relative;
      border-radius: 2px;
      // border: 1px solid #8b97a4;
      input {
        display: block;
        box-sizing: border-box;
        border: 1px solid #8b97a4;
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
      }
    }

    .open {
      transform: rotate(-90deg);
    }
  }
  .itemchild {
    margin-left: 46px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Tree.vue